import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
export function UrgencyBanner() {
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-blueDeep text-brand-cream shadow-md" data-id="element-356" data-mp="2ikd9jpd6yf9k">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-357" data-mp="2nhdhk5tlps3b">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-358" data-mp="2sagd2jhxvbm5">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-359" data-mp="2wbrsjw73mggm">
            <FlameIcon className="h-4 w-4" data-id="element-360" data-mp="319tb8g0m4drk" />
            <span data-id="element-361" data-mp="318s3akew87e2">PRECIO ESPECIAL DE LANZAMIENTO POR TIEMPO LIMITADO</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-362" data-mp="36a7j9y27rnpl" />
          <span data-id="element-363" data-mp="3b893wnfafv36">Acceso inmediato · 100% digital · Disponible en Latinoamérica</span>
          <a href="#comprar" className="rounded-full bg-brand-amber px-3 py-1 text-xs font-bold text-brand-blueDeep transition-colors duration-150 ease-out hover:bg-brand-goldLight" data-id="element-364" data-mp="3b66ea4i1s3yz">
            VER EL KIT →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-365" data-mp="27f86dg5dj78x">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-366" data-mp="27gt1p7ziiu7u">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-367" data-mp="1sremvkd63kl2">
                <span data-id="element-368" data-mp="2qdc31b42rdtu">
                  🔥 <strong data-id="element-369" data-mp="2qcj42wbcxsm9">Precio especial de lanzamiento</strong> por tiempo limitado
                </span>
                <span data-id="element-370" data-mp="2lfiuibfau7qe">•</span>
                <span data-id="element-371" data-mp="2lfamoxy19sm2">Acceso inmediato · 100% digital · Latinoamérica</span>
                <a href="#comprar" className="rounded-full bg-brand-amber px-2.5 py-1 text-brand-blueDeep" data-id="element-372" data-mp="2ge39gjd4g180">
                  VER EL KIT →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}